import * as React from 'react';
import { isPartialDate, sortPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';

import TileContentMaker from 'Components/DashboardTile/TileContentMaker';

const _BPDash = ({ documents }: IOwnProps): React.JSX.Element | undefined => {
  const sortedArr = documents?.toSorted((n1, n2) => sortPartialDate(n2.date, n1.date) || n2._cdate - n1._cdate);
  return (
    <TileContentMaker
      type="recentList"
      data={sortedArr.map(d => ({
        key: d._id,
        date: isPartialDate(d.date) ? formatPartialDate(d.date) : '',
        title: '',
        value: '',
      }))}
    />
  );
};

interface IOwnProps {
  documents: Array<any>;
}

export default _BPDash;
